<template>
  <ReportMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
